import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  q: '¿Cómo recibo el material?',
  a: 'Una vez confirmado el pago, recibirás de forma inmediata un correo electrónico con el enlace para descargar todo el sistema, los módulos y los bonus en formato PDF, listos para usar.'
}, {
  q: '¿Sirve si recién empiezo a atender?',
  a: 'Sí, absolutamente. El sistema está diseñado para brindarte una estructura paso a paso, dándote seguridad y claridad sobre qué preguntar, cómo evaluar y qué técnicas aplicar en cada sesión.'
}, {
  q: '¿Es compatible con TCC-I (Terapia Cognitivo-Conductual para el Insomnio)?',
  a: 'Totalmente. El sistema se basa en principios cognitivo-conductuales, pero adaptados específicamente para diferenciar y tratar el insomnio cuando está mediado por cuadros de ansiedad o depresión.'
}, {
  q: '¿Hay garantía?',
  a: 'Sí, tenés 7 días de garantía. Si sentís que el material no aporta valor a tu práctica clínica, podés solicitar la devolución del 100% de tu dinero.'
}, {
  q: '¿Es un curso en video o material descargable?',
  a: 'Es un sistema clínico en formato texto/PDF descargable. Está pensado para ser una herramienta de consulta rápida y aplicación directa en el consultorio, sin tener que ver horas de video.'
}, {
  q: '¿Cómo se hace el pago?',
  a: 'El pago se realiza a través de una plataforma segura (MercadoPago u otras opciones disponibles en el checkout) donde podés usar tarjeta de crédito, débito o saldo en cuenta.'
}, {
  q: '¿Funciona para terapeutas que no son psicólogos?',
  a: 'El material está diseñado con lenguaje y estructura clínica para profesionales de la salud mental (psicólogos, psiquiatras, counselors) que abordan trastornos del sueño y del estado de ánimo.'
}];
export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 bg-offwhite px-4 sm:px-6 lg:px-8" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <h2 className="font-serif text-3xl font-bold text-navy mb-10 text-center" data-id="element-52">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-53">
          {FAQS.map((faq, idx) => <div key={idx} className="bg-white border border-lavender-muted rounded-lg overflow-hidden shadow-sm" data-id="element-54">
              <button onClick={() => toggleFAQ(idx)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === idx} data-id="element-55">
                <span className="font-semibold text-navy pr-4" data-id="element-56">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-57">
                  <ChevronDown className="w-5 h-5 text-accent shrink-0" data-id="element-58" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-59">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-60">
                    <div className="px-6 pb-4 text-gray-600 border-t border-gray-50 pt-3" data-id="element-61">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};